// services
import React, { Fragment, useState } from "react";
// import { styles } from "../../../static/js/materialStyle";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { Card, CardContent } from "@material-ui/core/";
import { Paper } from "../../../Components/Paper/Paper";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import PhoneIcon from "@material-ui/icons/Phone";
import ToolTip from "../../../Components/ToolTip/ToolTip";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import Grid from "../../../Components/Grid/Grid";
import Typography from "../../../Components/Typography/Typography";

const distance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
  var R = 6371; // km (change this constant to get miles)
  var dLat = ((lat2 - lat1) * Math.PI) / 180;
  var dLon = ((lon2 - lon1) * Math.PI) / 180;
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return Math.round(d * 1000);
};

const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

const NetworkView = (props: any) => {
  const [showHours, setShowHours] = useState<any>([]);
  let d = new Date();
  let hour = d.getHours();
  let isOnline = false;
  let { allbranches } = props;
  const cardsArray = allbranches.map((ele: any, index: any) => (
    <Paper
      elevation={4}
      key={ele._id}
      style={{ margin: "12px 0 12px 0", padding: "4px" }}
    >
      <h2 style={{ textAlign: "center",margin:"0" }}>{ele.cityName}</h2>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
      >
        {" "}
        {ele.branches &&
          ele.branches.length > 0 &&
          ele.branches.map((branch: any) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={branch._id}
              // style={{ margin: "2px" }}
              // className={styles.innercard}
            >
              <Card
              // className={styles.card}
              >
                <CardContent>
                  {branch.userLocation.length > 0 &&
                  branch.bLocation &&
                  distance(
                    branch.userLocation[0].location.coordinates[1],
                    branch.userLocation[0].location.coordinates[0],
                    branch.bLocation.coordinates[1],
                    branch.bLocation.coordinates[0]
                  ) <= 500
                    ? (isOnline = true)
                    : (isOnline = false)}
                  <Typography
                    variant={"h5"}
                    gutterBottom
                    style={{display:"flex",justifyContant:"flex-start",alignItems:"center"}}
                    // className={styles.title}
                  >
                    {branch.branchName.toUpperCase()}
                    {branch.operation && branch.operation.booking ? (
                      <ToolTip title="Booking">
                        <img
                          src={"/branch_list.png"}
                          style={{ width: "45px", height: "45px" }}
                        />
                      </ToolTip>
                    ) : (
                      ""
                    )}
                    {branch.operation && branch.operation.delivery ? (
                      <ToolTip title="Delivery">
                        <img
                          src={"/delivery_list.png"}
                          style={{ width: "45px", height: "45px" }}
                        />
                      </ToolTip>
                    ) : (
                      ""
                    )}
                    <span style={{ float: "right" }}>
                      {isOnline && (
                        <Brightness1Icon style={{ color: "green" }} />
                      )}
                    </span>
                  </Typography>
                  {/* <Typography variant={"h6"} gutterBottom className={styles.title}>
        {branch.company.companyName.toUpperCase()}
      </Typography> */}
                  <Typography
                    // className={styles.title}
                    style={{ fontSize: "12px" }}
                    color="textPrimary"
                    gutterBottom
                  >
                    {branch.bLocation && (
                      <span>
                        <a
                          href={
                            iOS === true
                              ? `comgooglemapsurl://maps.google.com/maps?z=12&t=m&q=loc:${branch.bLocation.coordinates[1]}+${branch.bLocation.coordinates[0]}`
                              : `http://maps.google.com/maps?z=12&t=m&q=loc:${branch.bLocation.coordinates[1]}+${branch.bLocation.coordinates[0]}`
                          }
                          target="_blank"
                        >
                          <LocationOnIcon
                            style={{
                              color: "blue",
                              fontSize: "18px",
                              verticalAlign: "sub",
                            }}
                          />
                        </a>
                      </span>
                    )}
                    {branch.address.l1.toUpperCase()}
                  </Typography>
                  <Typography
                    // className={styles.pos}
                    style={{ fontSize: "12px" }}
                    color="textSecondary"
                  >
                    {branch.address.l2.toUpperCase()}
                  </Typography>
                  <Typography
                    variant="body2"
                    component="p"
                    style={{ fontSize: "12px" }}
                  >
                    Pin Code : {branch.address.pincode}
                  </Typography>
                  {branch.pContact && (
                    <Typography
                      variant="body2"
                      component="p"
                      style={{ fontSize: "12px" }}
                    >
                      Mobile :{" "}
                      <span>
                        <a href={`tel:${branch.pContact}`}>
                          <PhoneIcon
                            style={{
                              color: "blue",
                              fontSize: "16px",
                              verticalAlign: "sub",
                            }}
                          />
                        </a>
                      </span>{" "}
                      {branch.pContact}
                      {branch.sContact && (
                        <span>
                          ,{" "}
                          <a href={`tel:${branch.sContact}`}>
                            <PhoneIcon
                              style={{
                                color: "blue",
                                fontSize: "16px",
                                verticalAlign: "sub",
                              }}
                            />
                          </a>
                        </span>
                      )}{" "}
                      {branch.sContact ? ` ${branch.sContact}` : ""}
                    </Typography>
                  )}
                  <Typography
                    variant="body2"
                    component="p"
                    style={{ fontSize: "12px" }}
                  >
                    City :{branch.address.cityName}
                  </Typography>
                  <Typography
                    variant="body2"
                    component="p"
                    style={{ fontSize: "12px" }}
                  >
                    State :{branch.address.stateName}
                  </Typography>
                  {branch.manager && (
                    <Typography
                      variant="body2"
                      component="p"
                      style={{ fontSize: "12px" }}
                    >
                      Reporting Manager :{" "}
                      {`${branch.manager.name.fName} ${branch.manager.name.lName}`}
                      , {branch.manager.contact}
                    </Typography>
                  )}
                  {branch.working && branch.working.regular && (
                    <Typography
                      variant="body2"
                      component="div"
                      style={{ fontSize: "12px" }}
                    >
                      Hours:
                      {hour >=
                        new Date(branch.working.regular.regStart).getHours() &&
                      hour <
                        new Date(branch.working.regular.regEnd).getHours() ? (
                        <span>
                          <span style={{ color: "green", fontWeight: 900 }}>
                            Open -
                          </span>{" "}
                          <span>
                            Closes{" "}
                            {new Date(
                              branch.working.regular.regEnd
                            ).getHours() < 10
                              ? "0" +
                                new Date(
                                  branch.working.regular.regEnd
                                ).getHours()
                              : new Date(
                                  branch.working.regular.regEnd
                                ).getHours()}
                            :
                            {new Date(
                              branch.working.regular.regEnd
                            ).getMinutes() < 10
                              ? "0" +
                                new Date(
                                  branch.working.regular.regEnd
                                ).getMinutes()
                              : new Date(
                                  branch.working.regular.regEnd
                                ).getMinutes()}
                          </span>
                          <span>
                            {" "}
                            {showHours[index] ? (
                              <ArrowDropUpIcon
                                style={{ verticalAlign: "middle" }}
                                onClick={() => setShowHours({ [index]: false })}
                              />
                            ) : (
                              <ArrowDropDownIcon
                                style={{ verticalAlign: "middle" }}
                                onClick={() => setShowHours({ [index]: true })}
                              />
                            )}
                          </span>
                        </span>
                      ) : (
                        <span>
                          <span style={{ color: "red" }}>Closed -</span> Opens
                          at{" "}
                          {new Date(
                            branch.working.regular.regStart
                          ).getHours() < 10
                            ? "0" +
                              new Date(
                                branch.working.regular.regStart
                              ).getHours()
                            : new Date(
                                branch.working.regular.regStart
                              ).getHours()}
                          :
                          {new Date(
                            branch.working.regular.regStart
                          ).getMinutes() < 10
                            ? "0" +
                              new Date(
                                branch.working.regular.regStart
                              ).getMinutes()
                            : new Date(
                                branch.working.regular.regStart
                              ).getMinutes()}{" "}
                          <span>
                            {" "}
                            {showHours[index] ? (
                              <ArrowDropUpIcon
                                style={{ verticalAlign: "middle" }}
                                onClick={() => setShowHours({ [index]: false })}
                              />
                            ) : (
                              <ArrowDropDownIcon
                                style={{ verticalAlign: "middle" }}
                                onClick={() => setShowHours({ [index]: true })}
                              />
                            )}
                          </span>
                        </span>
                      )}
                    </Typography>
                  )}
                  {showHours[index] && (
                    <div style={{ fontSize: "12px" }}>
                      {branch.working.custom.map((element: any) => {
                        return (
                          <div>
                            <b>{element.cusDay.toUpperCase()} </b>{" "}
                            {new Date(element.cusStart).getHours() < 10
                              ? "0" + new Date(element.cusStart).getHours()
                              : new Date(element.cusStart).getHours()}
                            :
                            {new Date(element.cusStart).getMinutes() < 10
                              ? "0" + new Date(element.cusStart).getMinutes()
                              : new Date(element.cusStart).getMinutes()}{" "}
                            {"-"}{" "}
                            {new Date(element.cusEnd).getHours() < 10
                              ? "0" + new Date(element.cusEnd).getHours()
                              : new Date(element.cusEnd).getHours()}
                            :
                            {new Date(element.cusEnd).getMinutes() < 10
                              ? "0" + new Date(element.cusEnd).getMinutes()
                              : new Date(element.cusEnd).getMinutes()}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}{" "}
      </Grid>
    </Paper>
  ));
  return (
    <Fragment>
      {cardsArray.length > 0 ? (
        cardsArray
      ) : (
        <h2 style={{ textAlign: "center" }}>No records found</h2>
      )}
    </Fragment>
  );
};

export default NetworkView;
